export const SET_TITLE = 'SET_TITLE';
export const SET_ONCONFIRM = 'SET_ONCONFIRM';
